module.exports = new __parcel__URL__("cmip6-climdex-tmaxxf-access-cm2.4ab607bd.png").toString();